import type { CustomIcon } from '../../interfaces/CustomIcon';

export interface TableColumnModel {
  id: number;
  header?: string;
  subTitle?: string;
  key: string;
  type: TableColumnType;
  icon?: CustomIcon;
  sortable: boolean;
  frozen?: boolean;
  identifier?: string;
  value?: string | number;
  exportFormNames?: string;
}

// eslint-disable-next-line no-shadow
export enum TableColumnType {
  TEXT,
  USER,
  TEXT_WTIH_ICON,
  BUTTON_WITH_ICON,
  SQAURE_BUTTON_WITH_ICON,
  SELECT,
  PIPELINE
}
